import React, { memo } from "react";
import PropTypes from "prop-types";
import { BettoPrimaryButton } from "../BettoButton";
import {
	SecurityCardAction,
	SecurityCardDescription,
	SecurityCardHeader,
	SecurityCardIcon,
	SecurityCardRoot,
	SecurityCardTitle,
	SecurityStatusIcon,
} from "./elements";

const StatusComplete = () => (
	<svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
		<circle cx="10" cy="10" r="9" fill="#0362d4" />
		<path d="M6 10l3 3 5-6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const StatusWarning = () => (
	<svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
		<circle cx="10" cy="10" r="9" fill="#f97316" />
		<path d="M10 6v5M10 14h.01" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
	</svg>
);

export const BettoSecurityCard = memo(
	({ icon, title, description, isComplete, actionLabel, onAction, isActionDisabled }) => (
		<SecurityCardRoot>
			<SecurityCardHeader>
				<SecurityCardIcon>{icon}</SecurityCardIcon>
				<SecurityStatusIcon>{isComplete ? <StatusComplete /> : <StatusWarning />}</SecurityStatusIcon>
			</SecurityCardHeader>
			<SecurityCardTitle>{title}</SecurityCardTitle>
			<SecurityCardDescription>{description}</SecurityCardDescription>
			<SecurityCardAction>
				<BettoPrimaryButton
					variant={isComplete ? "secondary" : "primary"}
					fullWidth
					size="sm"
					disabled={isActionDisabled}
					onClick={onAction}>
					{actionLabel}
				</BettoPrimaryButton>
			</SecurityCardAction>
		</SecurityCardRoot>
	)
);

BettoSecurityCard.displayName = "BettoSecurityCard";

BettoSecurityCard.propTypes = {
	icon: PropTypes.node,
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	isComplete: PropTypes.bool,
	actionLabel: PropTypes.string.isRequired,
	onAction: PropTypes.func,
	isActionDisabled: PropTypes.bool,
};
